"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontSizeExtension = void 0;
const core_1 = require("@tiptap/core");
exports.FontSizeExtension = core_1.Extension.create({
    name: 'fontSize',
    addOptions() {
        return {
            types: ['textStyle'],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (element) => element.style.fontSize?.replace(/['"]+/g, ''),
                        renderHTML: (attributes) => {
                            if (!attributes.fontSize) {
                                return {};
                            }
                            return {
                                style: `font-size: ${attributes.fontSize}`,
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setFontSize: (fontSize) => ({ chain }) => {
                return chain().setMark('textStyle', { fontSize: fontSize }).run();
            },
            unsetFontSize: () => ({ chain }) => {
                // TODO: check type
                return chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run();
            },
            toggleFontSize: (fontSize) => ({ chain }) => {
                return chain().focus().toggleMark('textStyle', { fontSize: fontSize }).run();
            },
        };
    },
});
//# sourceMappingURL=font-size.js.map